export const makeErrorMapFrom = (e: any) => {
  const errorMap = new Map<string, string>();
  const firstError = e.inner?.[0];
  firstError && errorMap.set(firstError.path, firstError.message);
  return errorMap;
};
